<template>
  <footer>
    <div
      style="min-height: 23vh"
      class="container py-5 text-md-start text-center">
      <div class="row">
        <div class="col-md-4 mb-md-0 mb-4">
          <img src="/images/logo.svg" width="200" alt="Logo" />
          <div class="text-white footer-social-nav mt-4">
            <a
              v-if="socialData.facebook"
              style="cursor: pointer"
              v-on:click="goTO(socialData.facebook)"
              class="me-3 text-dark">
              <img src="/images/facebook.png" style="height: 25px; width: 25px"
            /></a>
            <a
              v-if="socialData.instagram"
              style="cursor: pointer"
              v-on:click="goTO(socialData.instagram)"
              class="me-3 text-dark"
              ><img
                src="/images/instagram.png"
                style="height: 25px; width: 25px"
            /></a>
            <a
              v-if="socialData.twitter"
              style="cursor: pointer"
              v-on:click="goTO(socialData.twitter)"
              class="me-3 text-dark"
              ><img src="/images/twitter.png" style="height: 25px; width: 25px"
            /></a>
            <a
              v-if="socialData.linkedin"
              style="cursor: pointer"
              v-on:click="goTO(socialData.linkedin)"
              ><img
                src="/images/linkedin-color.png"
                style="height: 25px; width: 25px"
            /></a>
          </div>
          <!-- <div class="text-white footer-social-nav mt-4">
            <a href="" class="social-icons"
              ><i class="bx bxl-facebook-square"></i
            ></a>
            <a href="" class="social-icons"><i class="bx bxl-twitter"></i></a>
            <a href="" class="social-icons"><i class="bx bxl-instagram"></i></a>
            <a href="" class="social-icons"
              ><i class="bx bxl-linkedin-square"></i
            ></a>
          </div> -->
        </div>
        <div class="col-md-3 mb-md-0 mb-4">
          <h5 class="font-18 mb-4">Navigation</h5>
          <div class="footer-vav font-14">
            <p>
              <a v-on:click="$router.push('/about-us')" class="cursor-pointer"
                ><span class="font-18 align-bottom"
                  ><i class="bx bx-chevron-right"></i
                ></span>
                About Us</a
              >
            </p>
            <p>
              <a
                v-on:click="$router.push('/contact?mobile=N')"
                class="cursor-pointer"
                ><span class="font-18 align-bottom"
                  ><i class="bx bx-chevron-right"></i
                ></span>
                Contact Us</a
              >
            </p>
            <p>
              <a v-on:click="$router.push('/terms')" class="cursor-pointer"
                ><span class="font-18 align-bottom"
                  ><i class="bx bx-chevron-right"></i
                ></span>
                Terms & Conditions</a
              >
            </p>
          </div>
        </div>
        <div class="col-md-5">
          <h5 class="font-18 mb-4">Information</h5>
          <p class="font-14">
            Nimbalkar Maratha Vadhu-Var Suchak is a trusted and respected
            matrimonial service dedicated to helping families find the right
            match for their loved ones.
          </p>
          <p>
            <span class="me-1"><i class="bx bxs-envelope"></i></span>
            Email:
            <a
              :href="'mailto:' + 'vadhuvarsuchak@gmail.com'"
              style="cursor: pointer"
              >vadhuvarsuchak@gmail.com</a
            >
          </p>
          <p>Mobile Numbers - 9422604867, 8600320420, 7588060989</p>
        </div>
      </div>
    </div>
  </footer>
  <!-- Login Modal  -->
  <!-- <TextModal ref="loginModal">
  <div>
    <Form @submit="getLogin()">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header px-md-5 border-0">
            <h5 class="modal-title" id="loginModalLabel">Login</h5>
            <button
              type="button"
              id="login-close"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body pt-0">
            <ul
              class="nav nav-pills mb-3 tab-style-1"
              id="login-tab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="email-tab"
                  data-bs-toggle="pill"
                  href="#tab_1"
                  role="tab"
                  aria-controls="tab_1"
                  aria-selected="true"
                  v-on:click="changeTab('email')"
                  >Email Address
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="phone-tab"
                  data-bs-toggle="pill"
                  href="#tab_2"
                  role="tab"
                  aria-controls="tab_2"
                  aria-selected="false"
                  v-on:click="changeTab('mobile')"
                  >Mobile Number</a
                >
              </li>
            </ul>
            <div class="tab-content form-style" id="login-tabContent">
              <div
                class="tab-pane fade show active"
                id="tab_1"
                role="tabpanel"
                aria-labelledby="eamil-tab"
              >
                <div class="form-group">
                  <label>Email Address</label>
                  <Field
                    type="email"
                    id="email"
                    class="form-control"
                    name="email"
                    placeholder="Email"
                    v-model="loginData.email"
                    rules="required:Email"
                    :validateOnInput="true"
                  />
                </div>
                <ErrorMessage name="email" class="validation-msg" />
              </div>
              <div
                class="tab-pane fade"
                id="tab_2"
                role="tabpanel"
                aria-labelledby="phone-tab"
              >
                <div class="form-group">
                  <label>Mobile Number</label>
                  <Field
                    type="text"
                    id="mobile_no"
                    class="form-control mobile_no"
                    name="mobile"
                    placeholder="Mobile Number"
                    v-slot="{ field }"
                    v-model="loginData.mobile"
                    rules="required:Mobile Number"
                    :validateOnInput="true"
                  >
                    <PhoneCode
                      id="mobile"
                      placeholder="Mobile Number"
                      v-model:countryCode="loginData.country_code"
                      v-model="loginData.mobile"
                      v-model:dialCode="loginData.dial_code"
                      v-bind="field"
                    />
                  </Field>
                </div>
                <ErrorMessage name="mobile" class="validation-msg" />
              </div>
              <div class="form-group align-items-center mb-3">
                <label>Password</label>
                <div class="input-group mb-3">
                  <Field
                    :type="newPasswordFieldType"
                    id="password"
                    name="password"
                    class="form-control password"
                    placeholder="Password"
                    v-model="loginData.password"
                    v-on:keydown.space="$event.preventDefault()"
                    rules="required:Password|minLength:6|password"
                    :validateOnInput="true"
                  /><span
                    class="input-group-text"
                    id="basic-addon2"
                    style="border-radius: 0px 8px 8px 0px"
                    ><a v-on:click="switchVisibilityNew" class="psw-icon"
                      ><img :src="imageNew" width="20" /></a
                  ></span>
                </div>
                <ErrorMessage name="password" class="validation-msg" />
              </div>
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  text-center
                "
              >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="rememberMe"
                  />
                  <label class="form-check-label" for="rememberMe">
                    Remember Me
                  </label>
                </div>
                <p class="text-md-right mb-0">
                  <a
                    v-on:click="ShowForget()"
                    class="text-color-2 cursor-pointer"
                  >
                    Forgot Password ?</a
                  >
                </p>
              </div>
              <div class="my-3 text-center">
                <button
                  type="button"
                  class="btn btn-lg btn-block btn-brand-1 px-5"
                  id="login-button"
                  v-on:click="getLogin()"
                >
                  Login
                   Login -->
  <!-- </button>
              </div>
              <div class="d-flex justify-content-center">
                <p class="mb-0 mr-1">Don't have an account ?</p>
                <a
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  v-on:click="ShowRegister()"
                  class="text-color-2 cursor-pointer"
                >
                  Register Free</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
  </TextModal> -->
  <!-- Forgot Password  -->
  <TextModal ref="forgetModal">
    <!-- <div
    class="modal fade login-modal"
    id="ForgotPassword"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  > -->
    <div>
      <Form @submit="forgotPassword()">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header px-md-5 border-0">
              <h5 class="modal-title" id="loginModalLabel">
                Forgot Password ?
              </h5>
              <button
                type="button"
                id="close-modal"
                class="btn-close"
                v-on:click="$refs.forgetModal.closeModal()"></button>
            </div>
            <div class="modal-body pt-0 form-style">
              <div class="form-group">
                <label for="">Enter your Email Id</label>
                <Field
                  type="email"
                  id="forget_email"
                  class="form-control"
                  name="forget_email"
                  placeholder="Email"
                  v-model="forgotData.email"
                  rules="required:Email"
                  :validateOnInput="true" />
              </div>
              <ErrorMessage name="forget_email" class="validation-msg" />
              <div class="text-center">
                <button class="btn btn-brand-1 btn-block" id="forgot-button">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </TextModal>

  <!-- Success Modal  -->
  <div
    class="modal fade"
    id="SuccessModal"
    tabindex="-1"
    aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <h5 class="modal-title" id="">Success</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body pt-0 text-center">
          <p class="font-20">You hava successful</p>
          <div class="text-center">
            <img src="images/success.svg" width="150" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import $ from "jquery";
import TextModal from "@/components/TextModal.vue";
// import PhoneCode from "@/components/PhoneCodePicker/PhoneCode";
// import Datepicker from "@vuepic/vue-datepicker";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  name: "MainFooter",
  components: {
    Form,
    Field,
    ErrorMessage,
    // Datepicker,
    // PhoneCode,
    TextModal,
  },
  data() {
    return {
      newPasswordFieldType: "password",
      PasswordFieldType: "password",
      image: "/images/show-psw.svg",
      imageNew: "/images/show-psw.svg",
      detail: {},
      currentTab: "email",
      loginData: {
        role: "USER",
      },
      forgotData: {},
      socialData: {},
      url: "",
    };
  },
  mounted() {
    this.getDetail();
    this.contactUs();
    //header scroll
    var header = document.getElementsByClassName("header")[0];
    function add_class_on_scroll() {
      header.classList.add("bg-header");
    }
    function remove_class_on_scroll() {
      header.classList.remove("bg-header");
    }
    window.addEventListener("scroll", function () {
      var scrollpos = window.scrollY;
      if (scrollpos > 10) {
        add_class_on_scroll();
      } else {
        remove_class_on_scroll();
      }
    });
    //       //Timeout OTP
    // $(document).ready(function(){
    //   var timeLeft = 30;
    // var elem = document.getElementById('otp_timer');
    // var timerId = setInterval(countdown, 1000);

    // function countdown() {
    //     if (timeLeft == -1) {
    //         clearTimeout(timerId);
    //         doSomething();
    //     } else {
    //         elem.innerHTML = '00:' + timeLeft;
    //         timeLeft--;
    //     }
    // }
    // $(this).addClass('saveNo')
    // });
    // function doSomething() {
    // alert("Sorry! Time Out, Please try again");
    // }
  },
  methods: {
    //Show hide psw
    password_show_hide(id) {
      var x = document.getElementById(id);
      var show_eye = document.getElementById("show_eye");
      var hide_eye = document.getElementById("hide_eye");
      hide_eye.classList.remove("d-none");
      if (x.type === "password") {
        x.type = "text";
        show_eye.style.display = "none";
        hide_eye.style.display = "block";
      } else {
        x.type = "password";
        show_eye.style.display = "block";
        hide_eye.style.display = "none";
      }
    },
    ShowRegister() {
      this.$emit("showRegister");
    },
    //Goto back
    goBack() {
      window.history.back();
    },
    goTO(link) {
      var url = this.$helperService.getUrl(link);
      window.open(url);

      window.history.back();
    },
    termsandcondition() {
      // window.open("/terms");
    },
    selectGender(gender) {
      this.detail.maritial_status_id = gender;
    },
    switchVisibilityNew() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.imageNew =
        this.imageNew === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    switchVisibility() {
      this.PasswordFieldType =
        this.PasswordFieldType === "password" ? "text" : "password";
      this.image =
        this.image === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    signup() {
      // if (this.isAcceptTermCondition == "0") {
      //   return this.$notify({
      //     type: "error",
      //     text: "Please accept terms and condition",
      //   });
      // }
      // this.detail.is_newsletter = this.is_newsletter,
      // this.detail.role = 'USER',
      // this.detail.isAcceptTermCondition = this.isAcceptTermCondition,
      this.$api
        .postAPI({
          _action: "/user/signup",
          _body: this.detail,
          _buttonId: "submit-Button",
        })
        .then((res) => {
          if (res && res.access_token) {
            this.getMeCall();
            localStorage.setItem("access_token", res.access_token);
            localStorage.setItem("userId", res.id);
            // localStorage.setItem("role", res.role);
            localStorage.setItem("email", this.detail.email);
            // this.$router.push("/otp"+"?p="+"S" );
            this.$refs.otpModal.showModal();
          }
        })
        .catch(() => {
          localStorage.removeItem("access_token");
        });
    },
    getDetail() {
      this.$api
        .getAPI({
          _action: "/cms/social-media",
        })
        .then((res) => {
          this.socialData = res;
        })
        .catch(() => {});
    },
    contactUs() {
      this.$api
        .getAPI({
          _action: "/cms/contact-us",
        })
        .then((res) => {
          this.email = res.email;
        })
        .catch(() => {});
    },
    ShowForget() {
      document.getElementById("login-close").click();
      (this.forgotData.email = ""), this.$refs.forgetModal.showModal();
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    getLogin() {
      if (this.currentTab == "mobile") {
        this.url = "/mobile-login";
      }
      if (this.currentTab == "email") {
        this.url = "/login";
      }
      this.$api
        .postAPI({
          _action: this.url,
          _body: this.loginData,
          _buttonId: "login-button",
        })
        .then((res) => {
          localStorage.setItem("access_token", res.access_token);
          this.getMeCall();
          document.getElementById("login-close").click();
          this.$router.push("/dashboard");
        });
    },
    forgotPassword() {
      this.$api
        .postAPI({
          _action: "/forgot/password",
          _body: this.forgotData,
          _buttonId: "forgot-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$refs.forgetModal.closeModal();
          // localStorage.setItem("access_token", res.access_token);
          // this.$router.push("/dashboard");
        });
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.$store.commit("setUser", res);
          if (res.gender) {
            localStorage.setItem("gender", res.gender);
          }
        })
        .catch(() => {});
    },
  },
};
</script>
